import { useInfiniteQuery, useQuery, useQueryClient } from 'react-query';
import axiosInstance from '../../Store/helper/axiosInstance';
import { ALL_SPECIALITY, GET_ACTIVITY_DATES } from '../QueryKeys/speciality.key';
import { GET_USER_ACTIVITIES } from '../QueryKeys/speciality.key';
import dayjs from 'dayjs';
const cacheTime = 600000;
const staleTime = 600000;
export const useGetAllSpeciality = (onSuccess, onError) => {
  return useQuery(ALL_SPECIALITY, () => axiosInstance.get('speciality/get_all_specialities'), {
    onSuccess,
    onError,
    select: (response) => response.data.data,
    cacheTime: cacheTime,
    refetchOnWindowFocus: false
  });
};
//https://dockerapidev.clirnet.com/cmsservice/rnv41/user/user_activities_date?user_master_id=11095
export const useActivityDates = (onSuccess, onError) => {
  return useQuery(
    GET_ACTIVITY_DATES,
    () => axiosInstance.get('user/user_activities_date'),
    {
      onSuccess,
      onError,
      select: (response) => response.data.data,

      cacheTime: cacheTime,
      refetchOnWindowFocus: false
    }
  );
};
// export const useGetActivities = (date = '', onSuccess, onError) => {
//   return useQuery(
//     GET_USER_ACTIVITIES,
//     () => axiosInstance.get(`user/user_activities?user_master_id=11095&date=${date}`),
//     {
//       onSuccess,
//       onError,
//       select: (response) => response.data.data,

//       cacheTime: cacheTime,
//       refetchOnWindowFocus: false
//     }
//   );
// };
export const useGetActivities = (onSuccess, onError) => {
  const queryClient = useQueryClient();
  // const dates = queryClient.getQueryData(GET_ACTIVITY_DATES)?.data?.data;
  var rangeDate = new Date();
  rangeDate.setDate(rangeDate.getDate() - 30);
  return useInfiniteQuery(
    [GET_USER_ACTIVITIES],
    () =>
      axiosInstance.get(
        `user/user_activities?from='${dayjs(rangeDate).format('YYYY-MM-DD')}'&to='${dayjs(
          new Date()
        ).format('YYYY-MM-DD')}'`
      ),
    {
      // enabled: dates?.length > 0,
      // staleTime: staleTime,
      // cacheTime: cacheTime,
      refetchOnWindowFocus: false,
      getNextPageParam: (lastPage, allPages) => {
        return undefined;

        // console.log('lastPages', lastPage?.data?.data, '__', dates, '\n', allPages);
        // if (allPages?.length) {
        // console.log(allPages, 'lastPages', lastPage?.data?.data, '__', dates);
        // return allPages.length;
        // } else {
        //   return undefined;
        // }
      }
      // onSuccess,
      // select: res => res.data.data
    }
  );
};
